import {decorate, observable} from 'mobx';
import {faCompressAlt} from '@fortawesome/free-solid-svg-icons';
import {BaseModel} from './base';

export class Transition extends BaseModel {
  static faIcon = faCompressAlt;

  searchableProperties = ['name'];

  populateAttributesFromStore(rootStore) {
    super.populateAttributesFromStore(rootStore);

    this.activeOperationFromStates = rootStore.operationStateStore.getByIds(this.activeOperationFromStateIds);
    this.activeOperationToState = rootStore.operationStateStore.getById(this.activeOperationToStateId);
    this.startingOperationFromStates = rootStore.operationStateStore.getByIds(this.startingOperationFromStateIds);
    this.startingOperationToState = rootStore.operationStateStore.getById(this.startingOperationToStateId);
    this.workplaceFromStates = rootStore.workplaceStateStore.getByIds(this.workplaceFromStateIds);
    this.workplaceToState = rootStore.workplaceStateStore.getById(this.workplaceToStateId);
  }
}

decorate(Transition, {
  createdAt: observable,
  createdBy: observable,
  updatedAt: observable,
  updatedBy: observable,
  deletedAt: observable,
  deletedBy: observable,
  id: observable,
  name: observable,
  description: observable,
  customActionIds: observable,
  activeOperationFromStateIds: observable,
  activeOperationFromStates: observable,
  activeOperationToStateId: observable,
  activeOperationToState: observable,
  activeOperationWorkflowId: observable,
  isInternal: observable,
  isWorkplaceExclusive: observable,
  startingOperationFromStateIds: observable,
  startingOperationFromStates: observable,
  startingOperationToStateId: observable,
  startingOperationToState: observable,
  startingOperationWorkflowId: observable,
  workplaceFromStateIds: observable,
  workplaceFromStates: observable,
  workplaceToStateId: observable,
  workplaceToState: observable,
  createdByUser: observable,
  updatedByUser: observable,
});
